module.exports = __webpack_public_path__ + "img/icon-like.6a14f743.svg";